{
  "it": {
    "directUpload": {
      "title": "Carica",
      "chooseFiles": "Scegli file",
      "dropzone": {
        "textMultiple": "Trascina i file qui per caricare",
        "text": "Trascina il file qui per caricare",
        "or": "o",
        "browse": "sfoglia"
      },
      "previewImage": {
        "remove": "Rimuovi"
      },
      "actions": {
        "upload": "Carica",
        "close": "Chiudi"
      }
    }
  }
}
